"use strict";

import angular from "angular";

import template from "./empty-layout.component.html";
import "./themes/empty-layout.component.scss";

class EmptyLayoutComponent {
    constructor(LoaderService) {
        this.LoaderService = LoaderService;
    }

    $onInit() {}

    $onChanges(changes) {}

    $onDestroy() {}
}

export { EmptyLayoutComponent };

EmptyLayoutComponent.$inject = ["LoaderService"];

const name = "emptyLayoutComponent";
const def = {
    controller: EmptyLayoutComponent,
    bindings: {},
    template
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
